import { useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const CARDS = [
  {
    emoji: "✈️",
    headline: "Forward your confirmations",
    body: "Email any flight, hotel, or restaurant confirmation to GulliverTravelsPlans@gmail.com — Claude reads it and adds it to the right trip automatically.",
    highlight: "GulliverTravelsPlans@gmail.com",
  },
  {
    emoji: "📸",
    headline: "Snap a photo, add a place",
    body: "Snap a photo of a menu, business card, or sign and email it to the same address. Include the travel date in the subject line (e.g. 'Dec 14') and Gulliver will add it to the right trip automatically.",
    highlight: null,
  },
  {
    emoji: "👥",
    headline: "Share with travel companions",
    body: "Invite friends or family to your trip. Everyone sees the same live itinerary — and their forwarded confirmations go straight in too.",
    highlight: null,
  },
  {
    emoji: "🗓️",
    headline: "Sync to your calendar",
    body: "Subscribe to a live calendar feed and every trip appears in Google or Apple Calendar automatically. Find the link in Profile → Settings.",
    highlight: null,
  },
  {
    emoji: "🛫",
    headline: "Weather, flights & reminders",
    body: "Get 5-day forecasts for your destination, live flight tracking, TSA wait times, and a check-in reminder email 24 hours before departure.",
    highlight: null,
  },
];

export default function OnboardingCards({ user, onDone }) {
  const [index, setIndex] = useState(0);
  const [exiting, setExiting] = useState(false);

  const card = CARDS[index];
  const isLast = index === CARDS.length - 1;

  const handleDismiss = async () => {
    setExiting(true);
    try {
      await setDoc(doc(db, "users", user.uid), { hasSeenOnboarding: true }, { merge: true });
    } catch (e) {
      console.warn("Onboarding flag save failed:", e);
    }
    setTimeout(onDone, 300);
  };

  const handleNext = () => {
    if (isLast) {
      handleDismiss();
    } else {
      setIndex(i => i + 1);
    }
  };

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 500,
      background: "rgba(0,0,0,0.55)",
      display: "flex", alignItems: "flex-end", justifyContent: "center",
      animation: "fadeIn 0.2s ease",
      opacity: exiting ? 0 : 1,
      transition: exiting ? "opacity 0.3s ease" : "none",
    }}>
      <div style={{
        background: "var(--paper-card)",
        borderRadius: "20px 20px 0 0",
        padding: "32px 24px 48px",
        width: "100%",
        maxWidth: 600,
        animation: "slideUp 0.25s ease",
      }}>

        {/* Progress dots */}
        <div style={{ display: "flex", justifyContent: "center", gap: 6, marginBottom: 32 }}>
          {CARDS.map((_, i) => (
            <div key={i} style={{
              width: i === index ? 20 : 6,
              height: 6,
              borderRadius: 3,
              background: i === index ? "var(--ink)" : "var(--border)",
              transition: "all 0.2s ease",
            }} />
          ))}
        </div>

        {/* Card content */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{ fontSize: 52, marginBottom: 20, lineHeight: 1 }}>{card.emoji}</div>
          <div style={{
            fontFamily: "var(--font-display)",
            fontSize: 22,
            fontWeight: 600,
            color: "var(--ink)",
            marginBottom: 14,
            lineHeight: 1.3,
          }}>
            {card.headline}
          </div>
          <div style={{
            fontSize: 15,
            color: "var(--ink-mid)",
            lineHeight: 1.6,
            maxWidth: 320,
            margin: "0 auto",
          }}>
            {card.body}
          </div>
          {card.highlight && (
            <div style={{
              marginTop: 16,
              display: "inline-block",
              background: "var(--paper-warm)",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius-sm)",
              padding: "8px 14px",
              fontSize: 13,
              fontWeight: 500,
              color: "var(--accent)",
              letterSpacing: 0,
            }}>
              {card.highlight}
            </div>
          )}
        </div>

        {/* Buttons */}
        <button
          onClick={handleNext}
          style={{
            width: "100%",
            background: "var(--ink)",
            color: "white",
            border: "none",
            borderRadius: "var(--radius-sm)",
            padding: "14px",
            fontFamily: "var(--font-body)",
            fontSize: 15,
            fontWeight: 500,
            cursor: "pointer",
            marginBottom: 12,
          }}
        >
          {isLast ? "Get started" : "Next"}
        </button>

        {!isLast && (
          <button
            onClick={handleDismiss}
            style={{
              width: "100%",
              background: "none",
              border: "none",
              fontFamily: "var(--font-body)",
              fontSize: 13,
              color: "var(--ink-faint)",
              cursor: "pointer",
              padding: "6px",
            }}
          >
            Skip
          </button>
        )}
      </div>
    </div>
  );
}
